import { useEffect, type ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { identifyUser, track } from '../lib/analytics'

let sessionTracked = false

export default function AuthGuard({ children }: { children: ReactNode }) {
  const { user, loading, fetchUser } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => { fetchUser() }, [fetchUser])

  useEffect(() => {
    if (!loading && !user) navigate('/login', { replace: true })
  }, [loading, user, navigate])

  useEffect(() => {
    if (user && !sessionTracked) {
      sessionTracked = true
      identifyUser(user)
      track('session_started')
    }
  }, [user])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-dvh bg-bg">
        <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) return null
  return <>{children}</>
}
